<template>
  <div class="mainV" :style="pageCategory == 2 ? {'paddingTop':`${statusBarHeight}px`,'backgroundColor':'#FFFFFF'} : ''">
    <!--使用自定义header 根据theme判断展示对应的view -->
    <div v-if="isShowH5CustomHader">
      <template >
        <component ref="compH"  :is="componentHeaderId">
        </component>
      </template>
    </div>

    <div class="page-container common-page" :style="pageCategory == 2 ? {'padding-bottom': '0'} : ''" v-loading.fullscreen.lock="isLoading">
      <create-page :data="config.components" v-if="!isLoading"></create-page>
      <!--使用模版并且设置了自定义了显示模版footer-->
      <div v-if="isShowh5Footer">
        <h5Footer
          :dataS="tempObj"
          v-if="isShowh5Footer"
        />
      </div>

      <!--使用自定义footer-->
      <div v-if="isShowH5CustomFooter">
        <template>
          <component ref="comp"   :is="componentId">
          </component>
        </template>

      </div>
    </div>



  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import CreatePage from "../../utils/commonPageVnodeCreate.js";
import h5Footer from "../h5Footer/h5Footer"
import API from "../../libs/axios";
import "../../libs/element";

export default {
  name: "commonpage",
  components: {
    CreatePage,
    h5Footer
  },
  data() {
    const pageNames = this.$route.path;
    console.log('pageNames----', pageNames)
    // const pageList = JSON.parse(localStorage.getItem('setPageConfigs'))
    // const pageConf = pageList.find(page => ((page.uri&&page.uri.includes(pageNames)) || (page.manual_url&&page.manual_url.includes(pageNames))));
    // const pageConf = this.$store.getters.getConfigByPage(pageNames);
    // this.loadSettings(pageConf);
    // this.setFooter(pageConf)
    // console.log(pageConf, 'pageConfpageConfpageConfpageConfpageConfpageConfpageConf9999')
    // this.chargeLogin(pageConf)
    new Promise((resolve) => {
      const pageConf = this.$store.getters.getConfigByPage(pageNames);
      resolve(pageConf)
    }).then((e) => {
      console.log('e---->', e)
      window.H5LOWCODE = true
      window.H5LOWCODE_PAGELOGO = e.pageLogo
      window.H5LOWCODE_PAGETITLE = e.pageTitle
      window.H5LOWCODE_PAGEDESC = e.pageAbstract
      window.H5LOWCODE_PAGELINK = `${window.location.href}`
      this.pageCategory = e.pageCategory
      if (e.pageCategory == 2) {
        document.title = e.pageTitle
      }
      this.getShare({
        imgUrl: e.pageLogo || "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-mini/app_logo.png",
        title: e.pageTitle || '伟东云平台',
        desc: e.pageAbstract || '',
        link: `${window.location.href}`,
      })
      e.pageBackgroundColor && this.setBackgroundColor(e.pageBackgroundColor)
      this.loadSettings(e);
      this.setFooter(e)
      this.chargeLogin(e)
    }).catch((error) => {
      console.log('error--->', error)
    })
    return {
      pageCategory: 0,
      isLoading: true,
      config: {},
      routerParams: {},
      isShowh5Footer: false,
      tempObj: null,

      isShowH5CustomFooter:false, // 是否显示h5自定义footer
      componentId:null,
      ids:null,


      isShowH5CustomHader:false, // 是否显示h5顶部自定义
      componentHeaderId:null,
      idsHeader:null,
      statusBarHeight: 0

    };
  },
  provide() {
    return {
      isDebug: this.$route.query.is_debug === "1973",
    };
  },

  computed: {
    ...mapGetters(["storeGetPageConfByName"]),
    // loader() {
    //   let templatData={}
    //
    //   try {
    //     // const footerTamplate = require.context("../../../src/modules/dynamic/components", true, /.vue$/); //测试路由
    //     const footerTamplate = require.context("../../../../../../src/modules/dynamic/components", true, /.vue$/);
    //     footerTamplate && footerTamplate.keys().forEach(async (key) => {
    //       let templateName = (key.split('.')[key.split('.').length-2]).split('/')[1];
    //       const el = footerTamplate(key).default
    //       templatData[templateName] = el
    //     });
    //   } catch (error) {
    //     console.log('自定义目录---->src/modules/dynamic/components不存在',error)
    //   }
    //   return templatData[this.ids]
    //
    //   // return () => import(`../components/${this.ids}`);
    // },
    // loaders() {
    //   let templatData={}
    //   try {
    //     // const footerTamplate = require.context("../../../src/modules/dynamic/components", true, /.vue$/); //测试路由
    //     const footerTamplate = require.context("../../../../../../src/modules/dynamic/components", true, /.vue$/);
    //     footerTamplate && footerTamplate.keys().forEach(async (key) => {
    //       let templateName = (key.split('.')[key.split('.').length-2]).split('/')[1];
    //       const el = footerTamplate(key).default
    //       templatData[templateName] = el
    //     });
    //   } catch (error) {
    //     console.log('自定义目录---->src/modules/dynamic/components不存在',error)
    //   }
    //   return templatData[this.idsHeader]
    //
    //   // console.log(this.idsHeader,'this.idsHeaderthis.idsHeader')
    //   // return () => import(`../components/headerCustom/${this.idsHeader}`);
    // },
  },
  watch: {
    $route() {
      const {params} = this.$route.query;
      const {path} = this.$route;
      console.log('path----', path)
      this.config = this.$store.getters.getConfigByPage(path);
      this.routerParams = params;
      this.setFooter(this.config)
      this.render();
      this.renderH();
    },
  },
  beforeCreate() {
    const pageBackgroundSetting = this.$store.state.dynamic.pageBackgroundSetting;
    document.querySelector('body').setAttribute('style', `background-color
    :${pageBackgroundSetting?pageBackgroundSetting.replace(/"/g,""):'rgba(255,255,255,1)'}`)
  },
  created() {
    const {params} = this.$route.query;
    const {path} = this.$route;
    this.config = this.$store.getters.getConfigByPage(path);
    this.routerParams = params;
    this.statusBarHeight = this.$route.query.statusBarHeight || 0;
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    ...mapMutations(["storeSetPageSettings"]),
    getShare(configObj) {
      const ourl = window.location.href.split('#')[0];
      var shlink = configObj.link || window.location.href.split('#')[0]
      API({
        url: `/common-services/v1/wx/getWeConfig`,
        method: 'Get',
        params: { url: ourl }
      }).then((res) => {
        if (res.success) {
          window.wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timeStamp,
            nonceStr: res.data.nonce,
            signature: res.data.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'checkJsApi'],
            openTagList: ['wx-open-launch-app'],
          })

          window.wx.ready(function () {
            window.wx.checkJsApi({
              jsApiList: ['wx-open-launch-app', 'updateAppMessageShareData'],
              success: function (res) {
                console.log('可用')
              },
              fail: (err) => {
                console.log(err, '不可用')
              },
            })
            //分享朋友以及qq
            window.wx.updateAppMessageShareData({
              title: configObj.title, // 分享标题
              desc: configObj.desc, // 分享描述
              link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: configObj.imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('成功')
                // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
              },
              complete() {
                console.log(434343);
              }
            })
            //分享朋友圈以及空间
            window.wx.updateTimelineShareData({
              title: configObj.title, // 分享标题
              link: shlink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: configObj.imgUrl, // 分享图标
              success: function () {
                // 用户点击了分享后执行的回调函数
                console.log('成功')
                // $.post("$ctx/activity/shareCount.do",{"unionid":"$!unionid"},function(){});
              },
            })
          })
        }
      })
    },
    setBackgroundColor(color) {
      document.querySelector('body').setAttribute('style', `background-color
      :${color?color.replace(/"/g,""):'rgba(255,255,255,1)'}`)
    },
    loader() {
      let templatData={}

      try {
        // const footerTamplate = require.context("../../../src/modules/dynamic/components", true, /.vue$/); //测试路由
        const footerTamplate = require.context("../../../../../../src/modules/dynamic/components", true, /.vue$/);
        footerTamplate && footerTamplate.keys().forEach(async (key) => {
          let templateName = (key.split('.')[key.split('.').length-2]).split('/')[1];
          const el = footerTamplate(key).default
          templatData[templateName] = el
        });
      } catch (error) {
        console.log('自定义目录---->src/modules/dynamic/components不存在，此报错属于正常范围可忽略',error)
      }

      console.log(templatData,this.ids,'this.idsthis.idsthis.idsatDatatemplatData')

      return templatData[this.ids]

      // return () => import(`../components/${this.ids}`);
    },
    loaders() {
      let templatData={}
      try {
        // const footerTamplate = require.context("../../../src/modules/dynamic/components", true, /.vue$/); //测试路由
        const footerTamplate = require.context("../../../../../../src/modules/dynamic/components", true, /.vue$/);
        footerTamplate && footerTamplate.keys().forEach(async (key) => {
          let templateName = (key.split('.')[key.split('.').length-2]).split('/')[1];
          const el = footerTamplate(key).default
          templatData[templateName] = el
        });
      } catch (error) {
        console.log('自定义目录---->src/modules/dynamic/components不存在',error)
      }
      console.log(templatData,this.idsHeader,'templatDatatemplatDatatemplatData')
      return templatData[this.idsHeader]

      // console.log(this.idsHeader,'this.idsHeaderthis.idsHeader')
      // return () => import(`../components/headerCustom/${this.idsHeader}`);
    },
    renderH(){

      this.componentHeaderId =  this.loaders();

      // this.loaders()
      //   .then(() => {
      //     // if this.loader can be called,
      //     // assign this module getter to component
      //     this.componentHeaderId = () => this.loaders();
      //   })
      //   .catch(() => {
      //     // failback to module not found block
      //     this.componentHeaderId = '';
      //   });
    },
    render() {
      // test this module getter can get specifiied module
      this.componentId = this.loader();
      console.log( this.componentId,' this.componentId this.componentId')
      // this.loader()
      //   .then(() => {
      //     // if this.loader can be called,
      //     // assign this module getter to component
      //     this.componentId = () => this.loader();
      //   })
      //   .catch(() => {
      //     // pre setted loader  () => import(`../components/${this.data.name}`); not working
      //     // failback to module not found block
      //     this.componentId = '';
      //   });
    },

    setFooter(pageConf) {
      setTimeout(() => {
        this.isShowh5Footer = false
        const pageEndSettingStatus = this.$store.state.dynamic.storePageEndSettingStatus;
        // console.log('pageEndSettingStatuspageEndSettingStatus0000',pageEndSettingStatus)
        //  if(pageConf.h5FooterType==1&&pageEndSettingStatus==1){
        if (pageConf.h5FooterType == 1&&pageEndSettingStatus==1) { // 自定义页面展示模版footer
          this.isShowh5Footer = true
          // console.log(this.$store.state.dynamic.pageEnd,'this.$store.state.dynamic.pageEnd')
          const pageEnd = JSON.parse(this.$store.state.dynamic.pageEnd);
          this.tempObj = pageEnd;
        }else {
          // console.log('pageEndSettingStatuspageEndSettingStatus',pageEndSettingStatus)
          const theme = sessionStorage.getItem('theme');
          if(pageEndSettingStatus==2){ // 使用自定义footer
            this.isShowH5CustomFooter = true;
            // console.log('fsadfasdfasdfsadfthemethemethemetheme9999',theme)
            switch(theme){
              case 'yingji':
                this.ids = 'mFooter';
                break;
              case 'anquanshengchan':
                this.ids = 'anquanFooter'; // 取的文件名称
                break;
              case 'shanghaijiaoda':
                this.ids = 'guanhuFooter'; // 取的文件名称
                break;
            }
            this.render();
          }}

        const storePageHeaderSettingStatus = this.$store.state.dynamic.storePageHeaderSettingStatus;
        // console.log('storePageHeaderSettingStatusstorePageHeaderSettingStatus',storePageHeaderSettingStatus)
        // 自定义header
        if(storePageHeaderSettingStatus=='2'){
          console.log('fasfsdf=++++++++++++')

          this.isShowH5CustomHader = true
          console.log('fsad11999999999')
          const theme = sessionStorage.getItem('theme');
          switch(theme){
            case 'yingji':
              this.idsHeader = 'mHeader';
              break;
            case 'anquanshengchan':
              this.idsHeader = 'anquanHeader';
              break;
            case 'shanghaijiaoda':
              this.idsHeader = 'guanhuHeader';
              break;
          }
          this.renderH();

        }

      }, 500)
    },
    loadSettings(pageConf) {
      setTimeout(() => {
        this.storeSetPageSettings(pageConf.blockContent.blockList);
        this.isLoading = false

      }, 500)
    },
    // 判断此页面是否需要登录
    chargeLogin(pageConf) {
      if (pageConf.loginType == 1) {
        if (!localStorage.getItem('token')) {
          const frontendConfig = JSON.parse(sessionStorage.getItem('frontendConfig'))
          this.frontendConfig = frontendConfig && frontendConfig.filter(item => {
            if (item.key === 'homepage') {
              return true;
            }
          })[0]
          let namePage = '';
          if (frontendConfig) {
            namePage = this.frontendConfig.value
          }
          this.$router.push({
            path: '/login',
            query: {
              name: namePage
            }

          })
        }
      }
    }
  },
};
</script>
<style lang="stylus">
.mainV{
  height auto
}
.page-container {
  padding-bottom 110px

  .block {
    width 100% !important
    height auto !important
    box-shadow none !important
    border-radius none !important
  }

  > .el-col-24 {
    width: 100%
  }

  /deep/ .el-tabs__nav-scroll {
    background-color #fff;
    padding: 0 10px;
  }



}
.el-tabs__item.is-active {
  color:rgb(14, 90, 252);
}

.el-tabs__item {
  font-size 16px
}



/**
// .page-container {
//   margin: 0 auto;
//   margin-top: 24px;
//   .isroot{
//     margin:0 auto;
//     > .el-col-24{
//       width:100%;
//       > .el-row{

//             width:1200px;
//             margin:0 auto;

//       }
//     }
//   }
// }
**/
</style>

